import { fetcher, getCoursePreviewFetcherToken } from "@/lib/api";

export type CourseProgressItem = {
  lessonId: string;
  completedAt: string;
};

export type CourseProgressResponse = {
  items: CourseProgressItem[];
  total: number;
  courseTotal: number;
  percent: number;
  previewMode?: boolean;
};

export type MarkCompleteResponse = {
  progress: {
    courseId: string;
    lessonId: string;
    completedAt: string;
  };
};

export async function markLessonComplete(
  courseId: string,
  lessonId: string,
  token: string,
): Promise<MarkCompleteResponse> {
  const res = await fetcher<MarkCompleteResponse>("/v1/progress/complete", {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: JSON.stringify({ courseId, lessonId }),
  });
  if (!res.success) throw new Error(res.error?.message);
  return res.data;
}

export async function fetchCourseProgress(
  courseId: string,
  token?: string,
): Promise<CourseProgressResponse> {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;
  const preview = getCoursePreviewFetcherToken();
  if (preview) headers["X-Preview-Token"] = preview;
  const res = await fetcher<CourseProgressResponse>(`/v1/progress/${courseId}`, {
    headers,
  });
  if (!res.success) throw new Error(res.error?.message);
  return res.data;
}
